import React, { FC } from 'react';
import OfferingTabMenu from './OfferingTabMenu';
import type { OfferingOutline } from './ClientOutlineTypes';
import { FlexAlign, FlexJustify } from '@src/types';
import { Flexbox } from '@src/views/containers';

interface PracticeTabProps {
    clientId: string;
    sowId: string;
    practiceName: string;
    offerings: OfferingOutline[];
    onOpenAddOfferingDialog?: () => void;
    disableAddOffering?: boolean;
}

const PracticeTab: FC<PracticeTabProps> = ( {
    clientId,
    sowId,
    practiceName,
    offerings,
    onOpenAddOfferingDialog,
    disableAddOffering,
} ) => {
    return (
        <div className={ 'practice-pane-children' }>
            <Flexbox
                align={ FlexAlign.CENTER }
                justify={ FlexJustify.START }
                className={ 'sow-pane-offerings-header' }
            >
                <span className={ 'sow-section-label' }>Offerings</span>
            </Flexbox>
            <OfferingTabMenu
                clientId={ clientId }
                sowId={ sowId }
                offerings={ offerings }
                onOpenAddOfferingDialog={ onOpenAddOfferingDialog }
                disableAddOffering={ disableAddOffering }
                emptyMessage={ `No ${ practiceName } Offerings for this SOW yet.` }
            />
        </div>
    );
};

export default PracticeTab;
